import React from 'react';

// MUI Components
import { Box, Divider, Skeleton } from '@mui/material';

const ContactDetailsSkeleton = ({ variant, rows = 3, columns = 2, isReturnAddress, isDncList, ...props }) => {
  const renderGridSkeleton = () => (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <Box key={rowIndex} className="detailsRow">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Box key={colIndex} className="detailsColumn">
              <Skeleton 
                variant="text" 
                width="40%" 
                height={16} 
                sx={{ marginBottom: '4px' }}
              />
              <Skeleton 
                variant="text" 
                width="80%" 
                height={20}
              />
            </Box>
          ))}
        </Box>
      ))}
    </>
  );

  const renderMailingTabSkeleton = () => (
    <Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="30 %" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Divider sx={{ marginBottom: '16px' }} />
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
    </Box>
  );

  const renderPropertyTabSkeleton = () => (
    <Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="30 %" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
    </Box>
  );

  const renderCustomFieldsSkeleton = () => (
    <Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="30 %" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
      <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px'}}>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
        <Box sx={{width: '100%'}}>
          <Skeleton variant="text" width="20%" height={24} />
          <Skeleton variant="rectangular" width="60%" height={28} sx={{ marginBottom: '8px' }} />
        </Box>
      </Box>
    </Box>
  );

  const renderMetadataSkeleton = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {/* 3 metadata items with proper spacing */}
      {Array.from({ length: 3 }).map((_, index) => (
        <Box key={index} sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Skeleton 
            variant="text" 
            width="50%" 
            height={16} 
            sx={{ fontSize: '16px' }}
          />
          <Skeleton 
            variant="text" 
            width="75%" 
            height={18}
            sx={{ fontSize: '18px' }}
          />
        </Box>
      ))}
      
      {/* Checkbox section with proper spacing */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px !important' }}>
        {Array.from({ length: 1 }).map((_, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              {isReturnAddress && 
              <>
                <Skeleton 
                  variant="rectangular" 
                  width={14} 
                  height={14} 
                  sx={{ borderRadius: '2px', flexShrink: 0 }}
                />
                <Skeleton 
                  variant="text" 
                  width="60%" 
                  height={16}
                  sx={{ fontSize: '16px' }}
                />
              </>
              }
              <>
                <Skeleton 
                  variant="rectangular" 
                  width={14} 
                  height={14} 
                  sx={{ borderRadius: '2px', flexShrink: 0 }}
                />
                <Skeleton 
                  variant="text" 
                  width="60%" 
                  height={16}
                  sx={{ fontSize: '16px' }}
                />
              </>
            </Box>
          ))}
      </Box>
    </Box>
  );

  const renderEditFormSkeleton = () => (
    <Box className="editFormLayout">
      {/* Three rows of form fields */}
      {Array.from({ length: 3 }).map((_, rowIndex) => (
        <Box key={rowIndex} className="editFormRow">
          {Array.from({ length: 2 }).map((_, colIndex) => (
            <Box key={colIndex} className="editFormColumn">
              <Skeleton 
                variant="text" 
                width="30%" 
                height={16} 
                sx={{ marginBottom: '8px' }}
              />
              <Skeleton 
                variant="rectangular" 
                width="100%" 
                height={42}
                sx={{ borderRadius: '4px' }}
              />
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );

  const renderNotesSkeleton = () => (
    <Box className="notesContent">
      <Skeleton variant="text" width="30%" height={24} sx={{ marginBottom: '16px' }} />
      <Box className="notesContainer">
        {Array.from({ length: 2 }).map((_, index) => (
          <Box key={index} className="noteItem" sx={{ marginBottom: '16px' }}>
            <Skeleton variant="text" width="100%" height={20} sx={{ marginBottom: '8px' }} />
            <Skeleton variant="text" width="80%" height={20} sx={{ marginBottom: '8px' }} />
            <Skeleton variant="text" width="50%" height={16} />
          </Box>
        ))}
      </Box>
      <Skeleton variant="rectangular" width="120px" height={36} sx={{ borderRadius: '4px' }} />
    </Box>
  );

  const renderCustomSkeleton = () => {
    if (!props.items) return null;
    
    return props.items.map((item, index) => (
      <Skeleton 
        key={index}
        variant={item.variant || 'text'}
        width={item.width || '100%'}
        height={item.height || 20}
        sx={item.sx || {}}
      />
    ));
  };

  const renderEngagementTabSkeleton = () => (
    <Box className="engagementTabContent">
      {/* Phone Calls Section */}
      <Box sx={{ marginBottom: '24px' }}>
        <Skeleton variant="text" width="25%" height={24} sx={{ marginBottom: '16px' }} />
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Skeleton variant="text" width="40%" height={16} />
            <Skeleton variant="text" width="60%" height={20} />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <Skeleton variant="text" width="40%" height={16} />
            <Skeleton variant="text" width="60%" height={20} />
          </Box>
        </Box>
      </Box>

      {/* Divider */}
      <Skeleton variant="rectangular" width="100%" height={1} sx={{ margin: '24px 0', backgroundColor: '#E5E5E5' }} />

      {/* QR Code Scans Section */}
      <Box sx={{ marginBottom: '24px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <Skeleton variant="text" width="25%" height={24} />
          <Skeleton variant="text" width="20%" height={16} />
        </Box>
        <Skeleton variant="text" width="80%" height={20} />
      </Box>

      {/* Divider */}
      <Skeleton variant="rectangular" width="100%" height={1} sx={{ margin: '24px 0', backgroundColor: '#E5E5E5' }} />

      {/* Website Visits Section */}
      <Box sx={{ marginBottom: '24px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
          <Skeleton variant="text" width="25%" height={24} />
          <Skeleton variant="text" width="20%" height={16} />
        </Box>
        <Skeleton variant="text" width="80%" height={20} />
      </Box>

      {/* Informational Note */}
      <Box sx={{ backgroundColor: '#f4f4f4', borderRadius: '8px', padding: '16px 20px', marginTop: '24px' }}>
        <Skeleton variant="text" width="90%" height={20} sx={{ textAlign: 'center' }} />
      </Box>
    </Box>
  );

  switch (variant) {
    case 'grid':
      return renderGridSkeleton();
    case 'edit-form':
      return renderEditFormSkeleton();
    case 'mailing-tab':
      return renderMailingTabSkeleton();
    case 'property-tab':
      return renderPropertyTabSkeleton();
    case 'custom-fields':
      return renderCustomFieldsSkeleton();
    case 'metadata':
      return renderMetadataSkeleton();
    case 'notes':
      return renderNotesSkeleton();
    case 'custom':
      return renderCustomSkeleton();
    case 'engagement-tab':
      return renderEngagementTabSkeleton();
    default:
      return renderGridSkeleton();
  }
};

export default ContactDetailsSkeleton; 